import React from 'react'
import {
    Form,
  Input,
  TextArea,
  Toast,
  Button,ImageUploader,Ellipsis,List,Picker,Modal,Dialog,NavBar,Image,Selector
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../MsgAdd/index.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    SaveNNFile,SaveMedia,GetSystemMemorys
  } from '../../service/service';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};


class Index extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            planetId: 0,
            fileList: [],
            videoInfo: {},
            userInfo: {},
            imgName: "",
            loading: false // 新增加载状态
        };
    }

    componentDidMount() {
        var that = this;

        const { location } = this.props;
        const { planetId, id } = location.state || {}; // 获取 URL 参数
        this.setState({
            planetId: planetId,
            id: id,
        })
        if (id) {
            
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    // 在组件中添加这个方法
    generateVideoThumbnail = (videoFile) => {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            video.src = URL.createObjectURL(videoFile);

            video.onloadedmetadata = () => {
                // 设置canvas尺寸
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                // 跳转到视频的10%处截取一帧
                video.currentTime = video.duration * 0.1;
            };

            video.onseeked = () => {
                // 绘制视频帧到canvas
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                // 转换为base64图片
                const thumbnail = canvas.toDataURL('image/jpeg');
                resolve(thumbnail);

                // 释放内存
                URL.revokeObjectURL(video.src);
            };

            video.onerror = () => {
                // 如果出错，返回默认图片
                resolve("https://api.weibinyi.com/images/niannian/4/46-09.png");
            };
        });
    };

    submitForm = () => {
        // 如果正在加载中，直接返回，避免重复提交
        if (this.state.loading) {
            Toast.show({ icon: 'fail', content: '请勿重复提交！' });
            return;
        }
        var that = this;
        if (this.state.imgName == "" || this.state.imgName == null) {
            Toast.show({ icon: 'fail', content: '请先上传文件！' });
            return;
        }
        var data = {
            FileUrl: this.state.imgName,
            OpenId: this.state.userInfo.openId,
            PlanetId: this.state.planetId,
            CreatorUserId: this.state.userInfo.id,
        };
        this.setState({ loading: true });
        SaveMedia(data).then(res => {
            this.setState({ loading: false });
            if (res.success) {
                Toast.show({ icon: 'success', content: '提交成功！' });
                setTimeout(() => {
                    that.props.navigate('/videos', { replace: true, state: { id: that.state.planetId } });
                }, 2000);
            }
        })

    }

    render() {

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/videos', { replace: true, state: { id: this.state.planetId } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'height': "6%" }}>
                    上传视频
                </NavBar>

                <div style={{ height: "94%", backgroundColor: "rgb(195 195 195)", paddingTop: "5%" }}>

                    <div style={{
                        display: "flex", justifyContent: "center", alignItems: "center", marginTop: "25%"
                    }}>

                        <ImageUploader
                            columns={1}
                            maxCount={1}
                            accept="video/*"
                            style={{ '--cell-size': '100px' }}
                            value={this.state.fileList || []}
                            defaultValue={this.state.fileList || []}
                            beforeUpload={async (file) => {
                                console.log('BeforeUpload - 文件信息:', file);
                                if (!(file instanceof File)) {
                                    Toast.show({ icon: 'fail', content: '无效的文件！' });
                                    return false;
                                }
                                if (!file.type.startsWith('video/')) {
                                    Toast.show({ icon: 'fail', content: '只能上传视频文件！' });
                                    return false;
                                }
                                if (file.size > 30 * 1024 * 1024) {
                                    Toast.show({ icon: 'fail', content: '文件大小不能超过30MB！' });
                                    return false;
                                }

                                var res = await GetSystemMemorys(this.state.planetId);
                                if (res.success) {
                                    var count = 0;
                                    res.result.map(item => {
                                        count += item.fileSize;
                                    })
                                    var maxSize = 300;
                                    var models = this.state.userInfo.planetSizes
                                        .filter(x => x.planetId == this.state.planetId);
                                    if (models != null && models.length > 0) {
                                        maxSize = models[0].fileSumSize;
                                    }
                                    if (count > maxSize) {
                                        Toast.show({ content: '该星球文件空间已满！' });
                                        return false;
                                    }
                                }
                                this.generateVideoThumbnail(file).then(thumbnail => {
                                    this.setState({ videoThumbnail: thumbnail });
                                });
                                const fileCopy = new File([file], file.name, { type: file.type });
                                return fileCopy;
                            }}
                            onChange={(fileList) => {
                                console.log('OnChange - 文件列表:', fileList);
                                this.setState({ fileList });
                            }}
                            upload={async (file) => {
                                try {
                                    console.log('Upload - 开始上传:', file);

                                    // 1. 验证文件对象
                                    if (!(file instanceof File)) {
                                        throw new Error('无效的文件对象');
                                    }

                                    // 2. 创建临时预览URL
                                    const tempUrl = URL.createObjectURL(file);
                                    console.log('临时预览URL创建成功:', tempUrl);

                                    // 3. 上传文件
                                    const formData = new FormData();
                                    formData.append('file', file);
                                    formData.append('userid', this.state.userInfo.id);
                                    formData.append('scoureName', "Video");
                                    formData.append('planetId', this.state.planetId);

                                    const response = await SaveNNFile(formData);
                                    console.log('上传响应:', response);

                                    // 4. 确保返回正确的URL格式
                                    let imageUrl;
                                    if (typeof response === 'string') {
                                        imageUrl = environment.apiEndpoint + `/NNFiles/Video/${response.result}`;
                                    } else if (response.result) {
                                        imageUrl = environment.apiEndpoint + `/NNFiles/Video/${response.result}`;
                                    } else {
                                        throw new Error('无效的服务器响应');
                                    }

                                    this.setState({
                                        imgName: response.result
                                    })
                                    // 5. 释放临时URL
                                    URL.revokeObjectURL(tempUrl);

                                    return {
                                        url: this.state.videoThumbnail || imageUrl  // 返回缩略图或视频URL
                                    };

                                } catch (error) {
                                    console.error('上传过程出错:', error);
                                    Toast.show({ icon: 'fail', content: '上传失败' });
                                    throw error;
                                }
                            }}
                            children={
                                <Image
                                    src={"https://api.weibinyi.com/images/niannian/4/46-09.png"}
                                    fit='fill'
                                    width={70}
                                    height={70}
                                />
                            }
                        />
                    </div>


                    <div style={{ marginTop: "6%" }}>
                        <div style={{
                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/46-10.png')"
                            , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                            , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                            , fontWeight: "600", color: "#fff"
                        }} onClick={() => {
                            this.submitForm();
                        }}>
                            点 击 保 存
                            </div>
                        <div style={{ textAlign: "center", margin: "6px 0px 1px 0px" }}>
                            温馨提示：
                            </div>
                        <div style={{ textAlign: "center" }}>
                            单次上传视频不能超过30M，可以上传多个。
                            </div>
                    </div>

                </div>


                <BottomMenu selectKey="home" position="absolute" />

            </div>
        )
    }
}

export default withNavigate(Index);